<template>
    <list-search :showsSearch="showsSearch" @search="search">
        <v-row>
            <v-col lg="3" sm="6">
                <v-text-field v-model="filter['filter.startsAt']" type="date" label="기간(시작일)" v-bind="inputProps" />
            </v-col>
            <v-col lg="3" sm="6">
                <v-text-field v-model="filter['filter.endsAt']" type="date" label="기간(종료일)" v-bind="inputProps" />
            </v-col>
            <v-col lg="3" sm="6">
                <v-select v-model="filter['_areaParent']" :items="areas_parents" item-text="name" item-value="_id" label="분야(대분류)" v-bind="inputProps" />
            </v-col>
            <v-col lg="3" sm="6">
                <v-select v-model="filter['_areaChild']" :items="areas_children" item-text="name" item-value="_id" label="분야(소분류)" v-bind="inputProps" />
            </v-col>
        </v-row>
        <v-row>
            <v-col lg="3" sm="6">
                <v-select v-model="filter['searchKey']" :items="searchKeys" item-text="text" item-value="value" label="검색대상" v-bind="inputProps" />
            </v-col>
            <v-col lg="9" sm="6">
                <v-text-field v-model="filter['searchValue']" label="검색어" v-bind="inputProps" />
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import api from "@/api";
import listSearch from "../dumb/list-search.vue";

const initialFilter = {
    startsAt: null,
    endsAt: null,
    _areaParent: null,
    _areaChild: null,
    searchKey: null,
    searchValue: null,
};

const inputProps = {
    persistentPlaceholder: true,
    "hide-details": true,
    dense: true,
    outlined: true,
};

const searchKeys = [
    { text: "전체", value: null },
    { text: "요청기업명", value: "requester.companyName" },
];

export default {
    components: { listSearch },
    props: ["value", "showsSearch"],
    computed: {
        isLong() {
            return this.type == "long";
        },
        areas_parents() {
            return this.areas?.filter(({ _parent }) => !_parent) || [];
        },
        areas_children() {
            return this.areas?.filter(({ _parent }) => _parent == this.filter._areaParent) || [];
        },
    },
    data() {
        return {
            inputProps,
            searchKeys,
            areas: [],
            filter: { ...initialFilter, ...(this.value || {}) },
        };
    },
    methods: {
        search() {
            this.$emit("input", this.filter);
            this.$emit("search");
        },
        async getAreas() {
            const { areas } = await api.console.areas.gets();
            this.areas = areas;
        },
    },
    mounted() {
        this.getAreas();
    },
};
</script>

<style></style>
